module.exports = __webpack_public_path__ + "img/hand-holding-seedling.2352b713.svg";